import { asciiTextValidation } from 'framework/form';

const outcomesValidation = {
  id: {
    type: 'string',
    required: false,
  },
  alias: {
    type: 'string',
    required: false,
  },
  name: {
    type: 'string',
    required: true,
    errorMessage: 'Business outcome is required',
    maxSize: 255,
    ...asciiTextValidation,
  },
  description: {
    type: 'string',
    required: false,
    maxSize: 255,
    ...asciiTextValidation,
  },
  status: {
    type: 'string',
    required: false,
  },
};

export const outcomesDashboardValidation = {
  businessOutcomes: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: outcomesValidation,
    },
  },
};

const outcomesArrayValidation = {
  businessOutcomes: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: outcomesValidation,
    },
  },
};

export default outcomesArrayValidation;
